import * as constants from './constants';

export const initialState = {
  loading: false,
  list: {},
  item: {},
  error: undefined,
};

const policiesReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.RESET_ERROR:
    case constants.FETCH_POLICIES:
    case constants.FETCH_POLICIES_FAIL:
    case constants.FETCH_POLICIES_SUCCESS:
    case constants.FETCH_POLICY:
    case constants.FETCH_POLICY_FAIL:
    case constants.FETCH_POLICY_SUCCESS:
    case constants.UPDATE_POLICY:
    case constants.UPDATE_POLICY_FAIL:
    case constants.UPDATE_POLICY_SUCCESS:
    case constants.ACCEPT_POLICY:
    case constants.ACCEPT_POLICY_FAIL:
    case constants.ACCEPT_POLICY_SUCCESS:
    case constants.ANNUL_POLICY:
    case constants.ANNUL_POLICY_FAIL:
    case constants.ANNUL_POLICY_SUCCESS:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export default policiesReducer;
